import { render } from "./UserAddReportError.vue?vue&type=template&id=9f852a02&scoped=true"
import script from "./UserAddReportError.vue?vue&type=script&lang=js"
export * from "./UserAddReportError.vue?vue&type=script&lang=js"

import "./UserAddReportError.vue?vue&type=style&index=0&id=9f852a02&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f852a02"]])

export default __exports__